import { useEffect, useState } from "react";
import "./style.scss";

interface IProps {
  customMessage?: string;
}

const Loader = ({ customMessage }: IProps) => {
  const [started] = useState(Date.now());
  const [seconds, setSeconds] = useState<number | undefined>(undefined);

  const deadline1Seconds = 10;
  const deadline2Seconds = 12;
  const deadline3Seconds = 30;

  useEffect(() => {
    const getTime = () => {
      const time = Date.now() - started;
      setSeconds(Math.floor(time / 1000));
    };

    const interval = setInterval(() => getTime(), 1000);
    return () => clearInterval(interval);
  }, [started]);

  return (
    <div className={`loader${!customMessage && seconds && seconds > deadline3Seconds ? ' loading-too-long' : ''}`}>
      <div className="loading-message">
        {customMessage && <div>{customMessage}</div>}
        {!customMessage && seconds && seconds > deadline1Seconds && <div>Učitavanje traje predugo...</div>}
        {!customMessage && seconds && seconds > deadline2Seconds && <div>Sačekajte još malo</div>}
        {!customMessage && seconds && seconds > deadline3Seconds && <div>Ili pokušajte ponovo za 2 minuta</div>}
      </div>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
